import { json, type DataFunctionArgs } from '@remix-run/node'
import { useLoaderData, type MetaFunction, Link } from '@remix-run/react'
import { GeneralErrorBoundary } from '#app/components/error-boundary.tsx'
import { Icon } from '#app/components/ui/icon.tsx'
import { Alert, Button } from '@intersport-digital/react'
import Breadcrumbs from '#app/components/Breadcrumbs/Breadcrumbs.tsx'
import { StoreResponse } from '#types/stores.js'
import React from 'react'

export async function loader({ params }: DataFunctionArgs) {
	const response = await fetch(
		`https://testservices.intersport.se/api/noselake/searcher/webstore/store?q=${params.store}`,
	)

	const storeResponse = (await response.json()) as StoreResponse

	return json({
		store: storeResponse.documentList.documents[0],
		googleApiKey: 'AIzaSyCsKShHnZPLKQKsF_AQEAbJ6PwsLipjxbw',
	})
}

export default function ProfileRoute() {
	const data = useLoaderData<typeof loader>()
	const { store } = data

	return (
		<div className="container">
			<Breadcrumbs
				items={[
					{ href: '/', label: 'Startsida' },
					{ href: '../..', label: 'Butiker' },
					{ href: '..', label: store.storenamefull },
					{ href: '.', label: 'Förhandsbokning' },
				]}
				backItem={{ href: '..', label: store.storename }}
			/>

			<div className="uds-page-title uds-page-title__with-dot  mt-md-7 mt-6">
				<h1 className="h-page">
					Förhandsboka skidor hos INTERSPORT {store?.storename}
				</h1>
				<div className="text-color-grey-700 mt-4 text-sm">
					Förhandsboka din vinterutrustning hos INTERSPORT {store?.storename}.
					Vi tillhandahåller{' '}
					{store.extendedassortment
						.map((x: string) => x.toLowerCase())
						.join(', ')}{' '}
					och har även service inom{' '}
					{store.extendedservices
						.map((x: string) => x.toLowerCase())
						.join(', ')}
					.
				</div>
			</div>

			{true ? (
				<ComingSoon />
			) : (
				<div className="mt-md-7 row mt-6">
					<div className="col-12 col-md-7 col-lg-8 col-xl-9 flex flex-col gap-8">
						<div>
							<span className="text-bold text-uppercase bg-primary p-2 px-3 text-white">
								Välj datum
							</span>
							<div className="optselector-item active mt-7">
								<div className="mb-8">datepicker</div>
								<Button
									type="button"
									size="small"
									variant="primary"
									role="link"
								>
									Fortsätt
								</Button>
							</div>
						</div>

						<div>
							<span className="text-bold text-uppercase bg-gray-400 p-2 px-3 text-white">
								Välj utrustning
							</span>
							<div className="my-6">utrustningsväljare</div>
						</div>

						<div>
							<span className="text-bold text-uppercase bg-gray-400 p-2 px-3 text-white">
								Bokningsinformation
							</span>
							<div className="my-6">information</div>
						</div>
					</div>

					<div className="col-12 col-md-5 col-lg-4 col-xl-3">
						<div className="price-breakdown bg-color-blue text-color-white px-6 py-7">
							<div className="d-flex justify-content-between mb-6">
								<span className="text-small ">Upphämtning</span>
								<span className="mobile-header-12-bold ">
									Onsdag 2023-12-05 @ 14:00
								</span>
							</div>
							<div className="d-flex justify-content-between mb-6">
								<span className="text-small ">Hyrtid</span>
								<span className="mobile-header-12-bold ">6 dagar</span>
							</div>
							<div className="divider divider--thin divider--white mb-7"></div>
							<ul className="mb-7">
								<li className="d-flex justify-content-between">
									<span className="text-regular ">2xSkidpaket vuxen</span>
									<span className="mobile-header-12-bold ">1899 kr</span>
								</li>
							</ul>
							<div className="divider divider--bold divider--white"></div>
							<div className="d-flex justify-content-between mt-7">
								<div className="text-bold-header ">Totalt</div>
								<span className="text-small  me-auto ms-3">1 hyrpaket</span>
								<span className="text-bold-header ">1899 kr</span>
							</div>
						</div>
						<div
							className="position-relative px-0 px-6"
							data-testid="ShoppingBag"
						>
							<ul className="shopping-bag--product-cards">
								<li>
									<figure
										data-testid="ShoppingBagItem"
										className="d-inline-flex product-card__shopping-bag product-card__shopping-bag--mini"
									>
										<div className="product-card__shopping-bag-image product-card__shopping-bag-image--mini">
											<img
												alt="Clifton 9 W löparskor"
												loading="lazy"
												width="300"
												height="300"
												decoding="async"
												data-nimg="1"
												src="https://cdn.intersport.se/cdn-cgi/imagedelivery/wT8bUgvMzuJDRcaEDgl0aQ/prod/140887201000_10/w=200,h=200,fit=pad,background=%23f8f9fa"
											/>
										</div>
										<figcaption className="flex-column justify-content-between pe-0 pr-0">
											<div className="product-info me-0">
												<div
													className="product-title max-lines max-lines--2 text-color-dark-blue"
													data-testid="Product_Title_PLP_variant"
												>
													<a
														className="product-brand text-decoration-none cursor-pointer"
														data-testid="link-component"
														href="/hoka one one"
													>
														ALPINT
													</a>
													<a
														className="product-model text-decoration-none max-lines max-lines--2 cursor-pointer"
														data-testid="link-component"
														href="/products/1538304/03"
													>
														Paket Junior
													</a>
												</div>
												<div
													className="product-config"
													data-testid="ShoppingBag__product-config"
												>
													<div className="product-color text-small">
														Färg:{' '}
														<span className="font-weight-bold text-uppercase">
															BLACK / WHITE
														</span>
													</div>
													<div
														data-testid="ShoppingBag__product-size"
														className="product-size text-small d-flex"
													>
														Storlek:{' '}
														<span className="font-weight-bold text-uppercase">
															6
														</span>
													</div>
												</div>
											</div>
											<div className="d-flex mt-auto">
												<div
													data-testid="QtyButtonContent"
													className="text-small d-flex fs-12"
												>
													Kvantitet:{' '}
													<span
														className="text-small-bold"
														data-testid="QtyButtonContent__amount"
													>
														1
													</span>
												</div>
											</div>
											<div className="product-numbers">
												<div
													className="d-header-14-bold  product-price justify-content-start align-items-start flex-row"
													data-testid="product-price"
												>
													<div className="product-price__current product-price__current--highlighted product-price__current--small product-price__original--small">
														<span className="text-lowercase">1424.25 kr</span>
													</div>
													<div className="product-price__original product-price__original--small">
														<span className="text-lowercase">1899 kr</span>
													</div>
												</div>
											</div>
										</figcaption>
									</figure>
								</li>
							</ul>
						</div>
					</div>
				</div>
			)}
		</div>
	)
}

const ComingSoon: React.FC<{}> = () => {
	return (
		<div className="mt-8">
			<Alert
				isWarning={true}
				isMultiLiner={true}
				headerContent={
					<span className="!text-sm font-bold">Öppnar snart!</span>
				}
				bodyContent={
					<span className="!text-sm">
						Skidhyran är för närvarande under uppbyggnad, men du är varmt välkommen att besöka vår butik för att hyra skidor. <br />
						Vi erbjuder drop-in hyrning för din bekvämlighet. 
						Tveka inte att besöka oss och få ut det mesta av din skidupplevelse!
					</span>
				}
				headerVariant="default"
			/>
		</div>
	)
}

export const meta: MetaFunction<typeof loader> = ({ data, params }) => {
	const displayName = data?.store?.storename
	return [
		{
			title: `Förhandsboka skidor hos INTERSPORT ${displayName} | INTERSPORT Rent`,
		},
		{
			name: 'description',
			content: `Hyr dina skidor hos ${displayName}`,
		},
	]
}

export function ErrorBoundary() {
	return (
		<GeneralErrorBoundary
			statusHandlers={{
				404: ({ params }) => (
					<p>Hittar inte någon butik som heter "{params.store}".</p>
				),
			}}
		/>
	)
}
